var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32083 0.889422L8.11122 6.67992C8.24503 6.81373 8.31848 6.99213 8.31848 7.1865C8.31848 7.37695 8.24503 7.55547 8.11122 7.68906L2.32632 13.4742C2.19241 13.608 2.0139 13.6816 1.82345 13.6816C1.63299 13.6816 1.45437 13.6081 1.32057 13.4742L0.894526 13.0481C0.76072 12.9143 0.686842 12.7357 0.686842 12.5452C0.686842 12.3548 0.76072 12.1763 0.894526 12.0424L5.75241 7.18449L0.888924 2.32122C0.755225 2.18741 0.681453 2.0089 0.681453 1.81834C0.681453 1.62788 0.755225 1.44948 0.888924 1.31557L1.31518 0.889422C1.5924 0.6123 2.0436 0.6123 2.32083 0.889422Z",
    fill: "#304059"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBlue);
export default __webpack_public_path__ + "static/media/right-blue.4ee560065c17941fec79f1ab358fc8ef.svg";
export { ForwardRef as ReactComponent };